import { Box, Group, LoadingOverlay, ScrollArea, Stack, Text, Title } from "@mantine/core";

import { TodoGroup } from "./helpers";
import TodoItem, { TodoItemData } from "./item";

interface TodoGroupedListProps {
  groupedTodos: TodoGroup[];
  loading: boolean;
  emptyMessage: string;
  height: string | number;
  contentInsetX?: string;
  showCheckbox?: boolean;
  onSelectTodo?: (todo: TodoItemData) => void;
  onCompleteTodo?: (id: number) => void;
  getTodoHref?: (todo: TodoItemData) => string;
}

const TodoGroupedList = ({
  groupedTodos,
  loading,
  emptyMessage,
  height,
  contentInsetX = "var(--mantine-spacing-xl)",
  showCheckbox = true,
  onSelectTodo,
  onCompleteTodo,
  getTodoHref,
}: TodoGroupedListProps) => (
  <Box pos="relative" h={height} style={{ minHeight: 0, width: "100%" }}>
    <LoadingOverlay visible={loading} />

    <ScrollArea h="100%">
      {groupedTodos.length === 0 && !loading ? (
        <Box py="xl" ta="center">
          <Text c="dimmed" fz={14}>
            {emptyMessage}
          </Text>
        </Box>
      ) : (
        <Stack gap={0}>
          {groupedTodos.map((group, groupIndex) => (
            <Box key={group.key} mt={groupIndex > 0 ? "xl" : 0}>
              <Group
                gap="md"
                style={{
                  paddingLeft: contentInsetX,
                  paddingRight: contentInsetX,
                  paddingTop: "var(--mantine-spacing-sm)",
                  paddingBottom: "var(--mantine-spacing-sm)",
                }}
              >
                <Title order={4} fz={20} c={group.isOverdue ? "red" : undefined}>
                  {group.title}
                </Title>

                {group.subtitle ? (
                  <Text fz={14} c="dimmed">
                    {group.subtitle}
                  </Text>
                ) : null}
              </Group>

              {group.todos.map((todo, todoIndex) => (
                <TodoItem
                  key={todo.id}
                  {...todo}
                  isLastItem={todoIndex === group.todos.length - 1}
                  contentInsetX={contentInsetX}
                  onClick={onSelectTodo ? () => onSelectTodo(todo) : undefined}
                  titleHref={getTodoHref?.(todo)}
                  showCheckbox={showCheckbox}
                  onComplete={onCompleteTodo}
                />
              ))}
            </Box>
          ))}
        </Stack>
      )}
    </ScrollArea>
  </Box>
);

export default TodoGroupedList;
